import { Box, Stack, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { metrcTabs } from "utilities/common";

const MetrcTab = () => {
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const metrcFilter = searchParams.get("tab"); // same as your first code
  const tabs = metrcTabs;

  return (
    <>
      {pathname === "/manages/metrc" && (
        <Box mb={2} className="cannabinoids-tabs">
          <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={{ background: "#ffffff" }}
          >
            {tabs.map((tab) => (
              <Link
                key={tab.value}
                to={`${pathname}?tab=${tab.value}`}
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="medium"
                  variant="text"
                  color={metrcFilter === tab.value ? "primary" : "inherit"}
                  sx={{
                    minWidth: "180px",
                    fontWeight: metrcFilter === tab.value ? "bold" : "normal",
                    borderBottom:
                      metrcFilter === tab.value ? "2px solid" : "2px solid transparent",
                    borderColor: metrcFilter === tab.value ? "primary.main" : "transparent",
                  }}
                >
                  {tab.key}
                </Button>
              </Link>
            ))}
          </Stack>
        </Box>
      )}
    </>
  );
};

export default MetrcTab